import styled from 'styled-components';

import threeDots from '@r1-frontend/ui-react/assets/img/icons/three-dots.svg';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const KebabMenu = styled.div`
    position: relative;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    background-image: url(${threeDots});
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
`;

export const MenuPopup = styled.div`
    position: absolute;
    top: 23px;
    right: -8px;
    min-width: 157px;
    border-radius: ${BorderRadius.componentRadius};
    overflow: hidden;
    background-color: ${COLORS.BgMain};
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    z-index: 1;
`;

export const MenuRow = styled.div`
    width: 100%;
    padding: 12px 24px;
    ${FONTS.XS};
    white-space: nowrap;
    cursor: pointer;
    user-select: none;

    &:hover {
        background-color: ${COLORS.GRAY_LIGHT};
    }
`;
